import { CheckCircle, Cancel } from "@mui/icons-material";

type BooleanFieldProps = {
  value: boolean;
  extraOptions?: { toggleShowFalseOnNull?: boolean };
};

export function BooleanField({ value, extraOptions }: BooleanFieldProps) {
  if (value === true) return <CheckCircle color="secondary" fontSize="large" />;
  if (extraOptions?.toggleShowFalseOnNull) return <Cancel color="disabled" fontSize="medium" />;
  return null;
}
